export default __webpack_public_path__ + "static/media/platypus.b6bf8886.png";